export default {
    SUCCESS: 'SUCCESS',
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    IMAGE: 'IMAGE',
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    DEFAULT: 'DEFAULT',
    HIGHLIGHT_COLOR: 'HIGHLIGHT_COLOR',
    SHAPE_COLOR: 'SHAPE_COLOR',
    LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
    RATIO_LANDSCAPE: 'RATIO_LANDSCAPE', // 16:9
    RATIO_VERTICAL: 'RATIO_VERTICAL', // 9:16
    RATIO_SQUARE: 'RATIO_SQUARE', // 1:1
    RATIO_CINEMATIC: 'RATIO_CINEMATIC', // 21 : 9
    RATIO_SOCIAL: 'RATIO_SOCIAL', // 4 : 5
    RATIO_PORTRAIT: 'RATIO_PORTRAIT', // 3:4
    RATIO_ULTRA_WIDE: 'RATIO_ULTRA_WIDE', // 2:1
    ACCOUNT_CHANGE: 'ACCOUNT_CHANGE',
    USER_SPACE_CHANGE: 'USER_SPACE_CHANGE',
    /** 警告弹窗底部按钮：对应 `FJWarningModal.module.less` 中 `.btn_box.warning` */
    WARNING: 'warning',
    /** 次级按钮：无额外样式类，与 `.btn_box` 默认样式一致 */
    CANCEL: '',
    /** 与 `FJImage` 等组件联动刷新 */
    REFRESH_IMAGE: 'REFRESH_IMAGE',
};
